// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeSame {\n  padding-top: 20px;\n}\n.bottomBtnBox{\n  margin: 48px 0 0 80px;\n  justify-content: space-around;\n}\n.bottomBtnBox .submitBtn{\n    cursor: pointer;\n    float: left;\n    text-align: center;\n    width: 217px;\n    height: 38px;\n    background: #003399;\n    border-radius: 3px;\n    line-height: 38px;\n    font-size: 14px;\n    font-weight: 400;\n    color: #fff\n}\n", ""]);
// Exports
module.exports = exports;
